module.exports = __webpack_public_path__ + "img/user.2865118f.jpg";